import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, serviceAreas } from '../data/content';
export function FinalCTA() {
  return <section id="contact" className="w-full bg-forest-900 py-16 lg:py-24" data-id="element-71" data-mp="3uei1jdqmbm1a">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-72" data-mp="c7k8s6xzx3t3">
        <h2 className="font-display text-4xl uppercase leading-tight text-white sm:text-5xl" data-id="element-73" data-mp="84ntoq7nzptw">
          Ready to reclaim your space?
        </h2>
        <p className="mt-4 text-lg text-forest-100" data-id="element-74" data-mp="m3dr66yebris">
          Call Javier&apos;s Junk Removal now for a free quote. Your clean space is one phone call
          away.
        </p>

        <a href={PHONE_HREF} className="mt-8 inline-flex items-center justify-center gap-3 rounded-md bg-ember-500 px-9 py-5 font-display text-2xl uppercase tracking-wide text-ink-900 transition-transform duration-150 ease-out hover:-translate-y-0.5 hover:bg-ember-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-white sm:text-3xl" data-id="element-75" data-mp="vtqbby2atioe">
          <PhoneIcon className="h-7 w-7" aria-hidden="true" data-id="element-76" data-mp="zuilctizvrlq" />
          {PHONE_DISPLAY}
        </a>

        <p className="mt-5 font-display text-base uppercase tracking-wide text-ember-500" data-id="element-77" data-mp="2h3rfwfzedbdn">
          Same-day or next-day service available
        </p>
        <p className="mt-2 text-sm text-forest-100" data-id="element-78" data-mp="2m21c8twuyi0u">{serviceAreas.join(' • ')}</p>

        <div className="mt-12 border-t border-white/10 pt-8" data-id="element-79" data-mp="2r2768gqlogm3">
          <p className="font-display text-xl uppercase leading-snug text-white sm:text-2xl" data-id="element-80" data-mp="2v3ip83eyy3lb">
            We handle the heavy lifting. You enjoy the clean space.
          </p>
        </div>
      </div>
    </section>;
}